import * as React from 'react';
import * as Sentry from '@sentry/react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './utils/userLocale/i18n';
import {VERSION} from './Version';

const isProduction = import.meta.env.PROD;

if (isProduction) {
  Sentry.init({
    dsn: 'https://9d8144be8807cacbe82a550da8f0b1e2@o552799.ingest.us.sentry.io/4507492845420544',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    release: `app@${VERSION}`
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
